/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ChangePasswordDTO, EmailDTO, LoginDTO, ResetPasswordDTO, ResetTokenDTO, TokenDTO } from "../models";
import {
  ChangePasswordDTOFromJSON,
  ChangePasswordDTOToJSON,
  EmailDTOFromJSON,
  EmailDTOToJSON,
  LoginDTOFromJSON,
  LoginDTOToJSON,
  ResetPasswordDTOFromJSON,
  ResetPasswordDTOToJSON,
  ResetTokenDTOFromJSON,
  ResetTokenDTOToJSON,
  TokenDTOFromJSON,
  TokenDTOToJSON
} from "../models";

export interface GeneratePasswordResetUrlsForAllUsersRequest {
  token: string;
}

export interface LoginRequest {
  loginDTO: LoginDTO;
}

export interface LogoutRequest {
  tokenDTO: TokenDTO;
  xAccessToken?: string;
}

export interface RefreshAccessTokenRequest {
  tokenDTO: TokenDTO;
}

export interface RequestResetPasswordRequest {
  emailDTO: EmailDTO;
}

export interface ResetPasswordRequest {
  resetPasswordDTO: ResetPasswordDTO;
}

export interface ResetPasswordForUserRequest {
  userId: number;
  changePasswordDTO: ChangePasswordDTO;
}

export interface VerifyResetTokenRequest {
  resetTokenDTO: ResetTokenDTO;
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
  /**
   */
  async generatePasswordResetUrlsForAllUsersRaw(
    requestParameters: GeneratePasswordResetUrlsForAllUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.token === null || requestParameters.token === undefined) {
      throw new runtime.RequiredError(
        "token",
        "Required parameter requestParameters.token was null or undefined when calling generatePasswordResetUrlsForAllUsers."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.token !== undefined) {
      queryParameters["token"] = requestParameters.token;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/auth/password/reset/all`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async generatePasswordResetUrlsForAllUsers(
    requestParameters: GeneratePasswordResetUrlsForAllUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.generatePasswordResetUrlsForAllUsersRaw(requestParameters, initOverrides);
  }

  /**
   */
  async loginRaw(
    requestParameters: LoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TokenDTO>> {
    if (requestParameters.loginDTO === null || requestParameters.loginDTO === undefined) {
      throw new runtime.RequiredError(
        "loginDTO",
        "Required parameter requestParameters.loginDTO was null or undefined when calling login."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/login`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LoginDTOToJSON(requestParameters.loginDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => TokenDTOFromJSON(jsonValue));
  }

  /**
   */
  async login(
    requestParameters: LoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TokenDTO> {
    const response = await this.loginRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async logoutRaw(
    requestParameters: LogoutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.tokenDTO === null || requestParameters.tokenDTO === undefined) {
      throw new runtime.RequiredError(
        "tokenDTO",
        "Required parameter requestParameters.tokenDTO was null or undefined when calling logout."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (requestParameters.xAccessToken !== undefined && requestParameters.xAccessToken !== null) {
      headerParameters["x-access-token"] = String(requestParameters.xAccessToken);
    }

    const response = await this.request(
      {
        path: `/api/auth/logout`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TokenDTOToJSON(requestParameters.tokenDTO)
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async logout(
    requestParameters: LogoutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.logoutRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async refreshAccessTokenRaw(
    requestParameters: RefreshAccessTokenRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TokenDTO>> {
    if (requestParameters.tokenDTO === null || requestParameters.tokenDTO === undefined) {
      throw new runtime.RequiredError(
        "tokenDTO",
        "Required parameter requestParameters.tokenDTO was null or undefined when calling refreshAccessToken."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/accessToken`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TokenDTOToJSON(requestParameters.tokenDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => TokenDTOFromJSON(jsonValue));
  }

  /**
   */
  async refreshAccessToken(
    requestParameters: RefreshAccessTokenRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TokenDTO> {
    const response = await this.refreshAccessTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async requestResetPasswordRaw(
    requestParameters: RequestResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.emailDTO === null || requestParameters.emailDTO === undefined) {
      throw new runtime.RequiredError(
        "emailDTO",
        "Required parameter requestParameters.emailDTO was null or undefined when calling requestResetPassword."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/resetToken/request`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EmailDTOToJSON(requestParameters.emailDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async requestResetPassword(
    requestParameters: RequestResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.requestResetPasswordRaw(requestParameters, initOverrides);
  }

  /**
   */
  async resetPasswordRaw(
    requestParameters: ResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.resetPasswordDTO === null || requestParameters.resetPasswordDTO === undefined) {
      throw new runtime.RequiredError(
        "resetPasswordDTO",
        "Required parameter requestParameters.resetPasswordDTO was null or undefined when calling resetPassword."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/password/reset`,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ResetPasswordDTOToJSON(requestParameters.resetPasswordDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async resetPassword(
    requestParameters: ResetPasswordRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.resetPasswordRaw(requestParameters, initOverrides);
  }

  /**
   */
  async resetPasswordForUserRaw(
    requestParameters: ResetPasswordForUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.userId === null || requestParameters.userId === undefined) {
      throw new runtime.RequiredError(
        "userId",
        "Required parameter requestParameters.userId was null or undefined when calling resetPasswordForUser."
      );
    }

    if (requestParameters.changePasswordDTO === null || requestParameters.changePasswordDTO === undefined) {
      throw new runtime.RequiredError(
        "changePasswordDTO",
        "Required parameter requestParameters.changePasswordDTO was null or undefined when calling resetPasswordForUser."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/password/user/{userId}`.replace(
          `{${"userId"}}`,
          encodeURIComponent(String(requestParameters.userId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ChangePasswordDTOToJSON(requestParameters.changePasswordDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async resetPasswordForUser(
    requestParameters: ResetPasswordForUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.resetPasswordForUserRaw(requestParameters, initOverrides);
  }

  /**
   */
  async verifyResetTokenRaw(
    requestParameters: VerifyResetTokenRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.resetTokenDTO === null || requestParameters.resetTokenDTO === undefined) {
      throw new runtime.RequiredError(
        "resetTokenDTO",
        "Required parameter requestParameters.resetTokenDTO was null or undefined when calling verifyResetToken."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/auth/resetToken/validate`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ResetTokenDTOToJSON(requestParameters.resetTokenDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async verifyResetToken(
    requestParameters: VerifyResetTokenRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.verifyResetTokenRaw(requestParameters, initOverrides);
  }
}
